export default __webpack_public_path__ + "static/media/chapter_five_base_cover.836c25f7.jpg";